import dayjs from "dayjs"

import { getCalculatedPeriod, langMapISO } from "../../Utils/utils"
import { COMPARE_IDS, getCompareRange } from "../Filters/CompareSelect/presets"

const ISO_DATE = "YYYY-MM-DD"
const DATE_FORMAT = "MMM D, YYYY"

/**
 * Turns a page's {period, compare} filter object (the shape shared by DashboardFiltersBlock,
 * Health's Header, etc.) into the "Data export period: ..." label ExportDataModal displays.
 * Kept as a plain function (not a hook) so any page's filters can go through it the same way.
 */
export const getExportPeriodLabel = (filters, { lang = "en", t = (value) => value } = {}) => {
  const formatRange = (from, to) =>
    `${dayjs(from).locale(langMapISO[lang]).format(DATE_FORMAT)} – ${dayjs(to)
      .locale(langMapISO[lang])
      .format(DATE_FORMAT)}`

  const mainRange = getCalculatedPeriod(filters?.period)
  if (!mainRange) return null
  const [rawFrom, rawTo] = mainRange
  if (!rawFrom || !rawTo) return null
  // The "custom" period shape returns its raw [from, to] as-is (not dayjs objects), unlike
  // every other branch of getCalculatedPeriod - normalize before calling dayjs methods on it.
  const from = dayjs.isDayjs(rawFrom) ? rawFrom : dayjs(rawFrom)
  const to = dayjs.isDayjs(rawTo) ? rawTo : dayjs(rawTo)
  const mainLabel = formatRange(from, to)

  if (!filters?.compare?.mode) return mainLabel

  const compareRange =
    filters.compare.mode === COMPARE_IDS.CUSTOM
      ? filters.compare.range
      : getCompareRange(
          { range: [from.format(ISO_DATE), to.format(ISO_DATE)] },
          filters.compare.mode
        )

  if (!compareRange?.[0] || !compareRange?.[1]) return mainLabel

  return `${mainLabel} ${t("compared to")} ${formatRange(compareRange[0], compareRange[1])}`
}
